// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 26/10/2023
 */

.Categories_title__jq-BR {
  text-align: center;
  font-size: 2rem;
  font-style: normal;
  font-weight: 500;
  margin-top: 5rem;
}

.Categories_container__sIrmY {
    border-radius: 0.5rem;
}

.Categories_typographyContainer__hEtVz {
  text-align: left;
}

.Categories_typography1__9co\\+e {
  font-size: 26px;
  padding: 1rem 0rem;
  font-weight: 600;
}

.Categories_typography2__mOnE- {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  padding-left: 0rem;
}

a,
a:active {
  text-decoration: none;
  color: #000;
}

.Categories_container__sIrmY {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 2rem;
  justify-content: center;
  min-height: 28rem;
  margin-bottom: 2rem;
  background: #486dac;
  padding-top: 2.8rem;
  padding-bottom: 2rem;
}

/* for 1 card */
.Categories_cardOne__VFC-7 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  margin: 0 1rem;
  margin-bottom: 1rem;
  border: 1px solid #657fad1a;
  background: #ffffff;
  /* box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.05); */
  height: 32rem;
  width: 50vw;
  transition: 0.5s;
  position: relative;
}

.Categories_imageOne__FeemQ {
  height: 20rem;
  width: 50vw;
  object-fit: cover;
  border-radius: 0.5rem;
  border: 1px solid #657fad46;
}

.Categories_descriptionOne__b2DBG {
  font-size: 1rem;
  font-weight: 400;
  text-align: center;
  width: 30rem;
  margin-top: 10rem;
  display: none;
  padding-bottom: 1rem;
  color: rgba(0, 0, 0, 0.671);
}

/* for 2 cards */
.Categories_cardTwo__sNPk8 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  margin: 0 1rem;
  margin-bottom: 1rem;
  border: 1px solid #657fad1a;
  background: #ffffff;
  /* box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.05); */
  height: 30rem;
  width: 40vw;
  transition: 0.5s;
  position: relative;
}

.Categories_imageTwo__oc\\+hm {
  height: 20rem;
  width: 40vw;
  object-fit: cover;
  border-radius:0.5rem;
  border: 1px solid #657fad46;
}

.Categories_descriptionTwo__CoDKL {
  font-size: 1rem;
  font-weight: 400;
  text-align: center;
  width: 35vw;
  margin-top: 10rem;
  display: none;
  padding-bottom: 1rem;
  color: rgba(0, 0, 0, 0.671);
}

/* for 3 cards */
.Categories_cardThree__2E7Th {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  margin: 0 1rem;
  margin-bottom: 1rem;
  border: 1px solid #657fad1a;
  background: #ffffff;
  /* box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.05); */
  height: 28rem;
  width: 25vw;
  transition: 0.5s;
  position: relative;
}

.Categories_imageThree__VewxW {
  height: 18rem;
  width: 25vw;
  object-fit: cover;
    border-radius: 0.5rem;
  border: 1px solid #657fad46;
}

.Categories_descriptionThree__NmUSU {
  font-size: 0.95rem;
  font-weight: 400;
  text-align: center;
  width: 22vw;
  margin-top: 10rem;
  display: none;
  padding-bottom: 1rem;
  color: rgba(0, 0, 0, 0.671);
}

/* for 4 cards */
.Categories_cardFour__98-0K {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0rem;
  margin: 0 1rem;
  margin-bottom: 1rem;
  border: 1.5px solid #657fad00;
  background: #ffffff;
  /* box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.05); */
  height: 32rem;
  width: 20vw;
  transition: 0.5s;
  position: relative;
  border-radius: 0.5rem;
}

.Categories_imageFour__7SXZe {
  height: 13rem;
  width: 18vw;
  object-fit: cover;
  border-radius: 0.5rem;
  border: 1px solid #657fad46;
  margin-top: 0.8rem;
}

.Categories_descriptionFour__uh3bX {
  font-size: 0.9rem;
  font-weight: 400;
  text-align: center;
  width: 17vw;
  margin-top: 1rem;
  display: flex;
  padding-bottom: 1rem;
  color: rgba(0, 0, 0, 0.671);
  margin-bottom: auto;
}

.Categories_cardItems__1wv8D {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  position: relative;
}

.Categories_label__es69G {
  margin-bottom: auto;
  margin-top: 12rem;

  text-align: center;
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 500;
  margin-top: 1rem;
}

.Categories_description__dLG4w {
  font-size: 0.95rem;
  font-weight: 400;
  text-align: center;
  width: 18rem;
  display: none;
  padding-bottom: 1rem;
}

.Categories_descriptionCollapsed__zD\\+qe {
  display: none;
  transition: max-height 0.3s ease-out;
  overflow: hidden;
  margin-top: 10rem;
}

.Categories_descriptionExpanded__E2evz {
  display: block;
  transition: max-height 0.3s ease-in;
  max-height: 10rem;
  margin-top: 2rem;
  font-size: 0.9rem;
  font-weight: 400;
  text-align: center;
  width: 15vw;
  margin-top: 1rem;
  display: flex;
  padding-bottom: 1rem;
  color: rgba(0, 0, 0, 0.671);
}

.Categories_button__8OILF {
  margin-top: auto;
  margin-bottom: 2rem;

  border-radius: 0.5rem;
  padding: 0.5rem 2.5rem;
  box-shadow: none;
  align-self: center;
}

/* for desktop only */
@media (min-width: 770px) {
}

@media (max-width: 995px) {
  .Categories_cardFour__98-0K {
    display: flex;
    margin-bottom: 1rem;
    width: 40vw;
  }

  .Categories_imageFour__7SXZe {
    height: 15rem;
    width: 38vw;
  }

  .Categories_label__es69G {
    font-size: 1rem;
    font-style: normal;
  }
  .Categories_descriptionFour__uh3bX {
    font-size: 0.8rem;
    font-weight: 400;
    text-align: center;
    width: 30vw;
    margin-top: 1rem;
    display: flex;
    padding-bottom: 1rem;
    color: rgba(0, 0, 0, 0.671);
    margin-bottom: auto;
    text-align:center
  }
}

/* for mobile */
@media (max-width: 770px) {

.Categories_container__sIrmY {
  margin-bottom: 0rem;
}

  .Categories_outerContainer__TgGXV {
    box-shadow: none;
    margin-bottom: 1.5rem;
  }

  .Categories_cardFour__98-0K {
    margin: 0.2rem;
    height: 25rem;
    padding: 0.5rem 0.4rem;
    transition: none;
    width: 80vw;
    margin-bottom: 1rem;
  }

  .Categories_imageFour__7SXZe {
    /* border-radius: 100%; */
    height: 12rem;
    width: 80vw;
    object-fit: cover;
    margin-top: 0rem;

  }

  .Categories_cardOne__VFC-7 {
    margin: 0.2rem;
    height: 19rem;
    padding: 0.5rem 0.4rem;
    transition: none;
    width: 80vw;
  }

  .Categories_imageOne__FeemQ {
    /* border-radius: 100%; */
    height: 12rem;
    width: 80vw;
    object-fit: cover;
  }

  .Categories_cardTwo__sNPk8 {
    margin: 0.2rem;
    height: 19rem;
    padding: 0.5rem 0.4rem;
    transition: none;
    width: 80vw;
  }

  .Categories_imageTwo__oc\\+hm {
    /* border-radius: 100%; */
    height: 12rem;
    width: 80vw;
    object-fit: cover;
  }

  .Categories_cardThree__2E7Th {
    margin: 0.2rem;
    height: 19rem;
    padding: 0.5rem 0.4rem;
    transition: none;
    width: 80vw;
  }

  .Categories_imageThree__VewxW {
    /* border-radius: 100%; */
    height: 12rem;
    width: 80vw;
    object-fit: cover;
  }

  .Categories_label__es69G {
    font-size: 1.2rem;
    font-weight: 400;
    margin-top: 0.5rem;
    margin-bottom: 0.4rem;
  }

  .Categories_button__8OILF {
    width: 100%;
    font-size: 1rem;
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    margin-top: auto;
    margin-bottom: 1rem;
  }
  .Categories_title__jq-BR {
    text-align: center;
    font-size: 2rem;
    font-style: normal;
    font-weight: 500;
    margin-top: 0rem;
  }
  .Categories_typographyContainer__hEtVz {
    text-align: left;
    margin-top: 0rem;
  }

  .Categories_typography1__9co\\+e {
    font-size: 20px;
    padding: 1rem 0;
    font-weight: 600;
    margin-top: 0rem;
  }

  .Categories_typography2__mOnE- {
    font-size: 1rem;
    margin-bottom: 0.5rem;
  }
  .Categories_descriptionFour__uh3bX {
    font-size: 0.8rem;
    font-weight: 400;
    text-align: center;
    width: 80vw;
    margin-top: 1rem;
    display: flex;
    padding-bottom: 1rem;
    color: rgba(0, 0, 0, 0.671);
    margin-bottom: auto;
    text-align:center
  }
}


/* for 5 cards */
.Categories_cardFive__U7djb {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0rem;
  margin: 0 0.8rem;
  margin-bottom: 1rem;
  border: 1.5px solid #657fad00;
  background: #ffffff;
  height: 30rem;
  width: 16vw;
  transition: 0.5s;
  position: relative;
  border-radius: 0.5rem;
}

.Categories_imageFive__aaG6a {
  height: 12rem;
  width: 14vw;
  object-fit: cover;
  border-radius: 0.5rem;
  border: 1px solid #657fad46;
  margin-top: 0.8rem;
}

.Categories_descriptionFive__D4tLx {
  font-size: 0.9rem;
  font-weight: 400;
  text-align: center;
  width: 14vw;
  margin-top: 1rem;
  display: flex;
  padding-bottom: 1rem;
  color: rgba(0, 0, 0, 0.671);
  margin-bottom: auto;
}

@media (max-width: 995px) {
  .Categories_cardFive__U7djb {
    width: 38vw;
    height: 28rem;
  }
  .Categories_imageFive__aaG6a {
    width: 36vw;
    height: 14rem;
  }
  .Categories_descriptionFive__D4tLx {
    width: 35vw;
    font-size: 0.8rem;
  }
}

@media (max-width: 770px) {
  .Categories_cardFive__U7djb {
    width: 80vw;
    height: 25rem;
    margin: 0.4rem 0;
  }
  .Categories_imageFive__aaG6a {
    width: 80vw;
    height: 12rem;
  }
  .Categories_descriptionFive__D4tLx {
    width: 80vw;
    font-size: 0.8rem;
  }
}

@media (min-width: 1646px) {
  .Categories_cardFive__U7djb {
    width: 15vw;
  }
  .Categories_imageFive__aaG6a {
    width: 13vw;
  }
  .Categories_descriptionFive__D4tLx {
    width: 13vw;
  }
}

@media (min-width: 1829px) {
  .Categories_cardFive__U7djb {
    width: 14vw;
  }
  .Categories_imageFive__aaG6a {
    width: 12vw;
  }
  .Categories_descriptionFive__D4tLx {
    width: 12vw;
  }
}

@media (min-width: 2059px) {
  .Categories_cardFive__U7djb {
    width: 13vw;
  }
  .Categories_imageFive__aaG6a {
    width: 11vw;
  }
  .Categories_descriptionFive__D4tLx {
    width: 11vw;
  }
}

/* Large screen 1646px and above */
@media (min-width: 1646px) {

  .Categories_cardFour__98-0K {
      width: 18vw;
  }
  .Categories_imageFour__7SXZe {
  width: 16vw;
  }
    .Categories_descriptionFour__uh3bX {
    width: 16vw;
  }

    .Categories_cardFive__U7djb {
    width: 12vw;
  }
  .Categories_imageFive__aaG6a {
    width: 11vw;
  }
  .Categories_descriptionFive__D4tLx {
    width: 11vw;
  }

}

@media (min-width: 1829px) {

  .Categories_cardFour__98-0K {
      width: 14vw;
  }
  .Categories_imageFour__7SXZe {
  width: 13vw;
  }
      .Categories_descriptionFour__uh3bX {
    width: 13vw;
  }
}

@media (min-width: 2059px) {

  .Categories_cardFour__98-0K {
      width: 15vw;
  }
  .Categories_imageFour__7SXZe {
  width: 14vw;
  }
      .Categories_descriptionFour__uh3bX {
    width: 14vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Home/Categories.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,sDAAsD;EACtD,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,sDAAsD;EACtD,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,sDAAsD;EACtD,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;IACf,qBAAqB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,sDAAsD;EACtD,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;;EAEjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;;EAEnB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;AACA;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,oBAAoB;IACpB,2BAA2B;IAC3B,mBAAmB;IACnB;EACF;AACF;;AAEA,eAAe;AACf;;AAEA;EACE,mBAAmB;AACrB;;EAEE;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,gBAAgB;;EAElB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,oBAAoB;IACpB,2BAA2B;IAC3B,mBAAmB;IACnB;EACF;AACF;;;AAGA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;;AAEA,kCAAkC;AAClC;;EAEE;MACI,WAAW;EACf;EACA;EACA,WAAW;EACX;IACE;IACA,WAAW;EACb;;IAEE;IACA,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;;AAEF;;AAEA;;EAEE;MACI,WAAW;EACf;EACA;EACA,WAAW;EACX;MACI;IACF,WAAW;EACb;AACF;;AAEA;;EAEE;MACI,WAAW;EACf;EACA;EACA,WAAW;EACX;MACI;IACF,WAAW;EACb;AACF","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 26/10/2023\r\n */\r\n\r\n.title {\r\n  text-align: center;\r\n  font-size: 2rem;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  margin-top: 5rem;\r\n}\r\n\r\n.container {\r\n    border-radius: 0.5rem;\r\n}\r\n\r\n.typographyContainer {\r\n  text-align: left;\r\n}\r\n\r\n.typography1 {\r\n  font-size: 26px;\r\n  padding: 1rem 0rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.typography2 {\r\n  font-size: 1.1rem;\r\n  margin-bottom: 0.5rem;\r\n  padding-left: 0rem;\r\n}\r\n\r\na,\r\na:active {\r\n  text-decoration: none;\r\n  color: #000;\r\n}\r\n\r\n.container {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  margin-top: 2rem;\r\n  justify-content: center;\r\n  min-height: 28rem;\r\n  margin-bottom: 2rem;\r\n  background: #486dac;\r\n  padding-top: 2.8rem;\r\n  padding-bottom: 2rem;\r\n}\r\n\r\n/* for 1 card */\r\n.cardOne {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  padding: 0;\r\n  margin: 0 1rem;\r\n  margin-bottom: 1rem;\r\n  border: 1px solid #657fad1a;\r\n  background: #ffffff;\r\n  /* box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.05); */\r\n  height: 32rem;\r\n  width: 50vw;\r\n  transition: 0.5s;\r\n  position: relative;\r\n}\r\n\r\n.imageOne {\r\n  height: 20rem;\r\n  width: 50vw;\r\n  object-fit: cover;\r\n  border-radius: 0.5rem;\r\n  border: 1px solid #657fad46;\r\n}\r\n\r\n.descriptionOne {\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  text-align: center;\r\n  width: 30rem;\r\n  margin-top: 10rem;\r\n  display: none;\r\n  padding-bottom: 1rem;\r\n  color: rgba(0, 0, 0, 0.671);\r\n}\r\n\r\n/* for 2 cards */\r\n.cardTwo {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  padding: 0;\r\n  margin: 0 1rem;\r\n  margin-bottom: 1rem;\r\n  border: 1px solid #657fad1a;\r\n  background: #ffffff;\r\n  /* box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.05); */\r\n  height: 30rem;\r\n  width: 40vw;\r\n  transition: 0.5s;\r\n  position: relative;\r\n}\r\n\r\n.imageTwo {\r\n  height: 20rem;\r\n  width: 40vw;\r\n  object-fit: cover;\r\n  border-radius:0.5rem;\r\n  border: 1px solid #657fad46;\r\n}\r\n\r\n.descriptionTwo {\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  text-align: center;\r\n  width: 35vw;\r\n  margin-top: 10rem;\r\n  display: none;\r\n  padding-bottom: 1rem;\r\n  color: rgba(0, 0, 0, 0.671);\r\n}\r\n\r\n/* for 3 cards */\r\n.cardThree {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  padding: 0;\r\n  margin: 0 1rem;\r\n  margin-bottom: 1rem;\r\n  border: 1px solid #657fad1a;\r\n  background: #ffffff;\r\n  /* box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.05); */\r\n  height: 28rem;\r\n  width: 25vw;\r\n  transition: 0.5s;\r\n  position: relative;\r\n}\r\n\r\n.imageThree {\r\n  height: 18rem;\r\n  width: 25vw;\r\n  object-fit: cover;\r\n    border-radius: 0.5rem;\r\n  border: 1px solid #657fad46;\r\n}\r\n\r\n.descriptionThree {\r\n  font-size: 0.95rem;\r\n  font-weight: 400;\r\n  text-align: center;\r\n  width: 22vw;\r\n  margin-top: 10rem;\r\n  display: none;\r\n  padding-bottom: 1rem;\r\n  color: rgba(0, 0, 0, 0.671);\r\n}\r\n\r\n/* for 4 cards */\r\n.cardFour {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  padding: 0rem;\r\n  margin: 0 1rem;\r\n  margin-bottom: 1rem;\r\n  border: 1.5px solid #657fad00;\r\n  background: #ffffff;\r\n  /* box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.05); */\r\n  height: 32rem;\r\n  width: 20vw;\r\n  transition: 0.5s;\r\n  position: relative;\r\n  border-radius: 0.5rem;\r\n}\r\n\r\n.imageFour {\r\n  height: 13rem;\r\n  width: 18vw;\r\n  object-fit: cover;\r\n  border-radius: 0.5rem;\r\n  border: 1px solid #657fad46;\r\n  margin-top: 0.8rem;\r\n}\r\n\r\n.descriptionFour {\r\n  font-size: 0.9rem;\r\n  font-weight: 400;\r\n  text-align: center;\r\n  width: 17vw;\r\n  margin-top: 1rem;\r\n  display: flex;\r\n  padding-bottom: 1rem;\r\n  color: rgba(0, 0, 0, 0.671);\r\n  margin-bottom: auto;\r\n}\r\n\r\n.cardItems {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  height: 100%;\r\n  width: 100%;\r\n  position: relative;\r\n}\r\n\r\n.label {\r\n  margin-bottom: auto;\r\n  margin-top: 12rem;\r\n\r\n  text-align: center;\r\n  font-size: 1.2rem;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.description {\r\n  font-size: 0.95rem;\r\n  font-weight: 400;\r\n  text-align: center;\r\n  width: 18rem;\r\n  display: none;\r\n  padding-bottom: 1rem;\r\n}\r\n\r\n.descriptionCollapsed {\r\n  display: none;\r\n  transition: max-height 0.3s ease-out;\r\n  overflow: hidden;\r\n  margin-top: 10rem;\r\n}\r\n\r\n.descriptionExpanded {\r\n  display: block;\r\n  transition: max-height 0.3s ease-in;\r\n  max-height: 10rem;\r\n  margin-top: 2rem;\r\n  font-size: 0.9rem;\r\n  font-weight: 400;\r\n  text-align: center;\r\n  width: 15vw;\r\n  margin-top: 1rem;\r\n  display: flex;\r\n  padding-bottom: 1rem;\r\n  color: rgba(0, 0, 0, 0.671);\r\n}\r\n\r\n.button {\r\n  margin-top: auto;\r\n  margin-bottom: 2rem;\r\n\r\n  border-radius: 0.5rem;\r\n  padding: 0.5rem 2.5rem;\r\n  box-shadow: none;\r\n  align-self: center;\r\n}\r\n\r\n/* for desktop only */\r\n@media (min-width: 770px) {\r\n}\r\n\r\n@media (max-width: 995px) {\r\n  .cardFour {\r\n    display: flex;\r\n    margin-bottom: 1rem;\r\n    width: 40vw;\r\n  }\r\n\r\n  .imageFour {\r\n    height: 15rem;\r\n    width: 38vw;\r\n  }\r\n\r\n  .label {\r\n    font-size: 1rem;\r\n    font-style: normal;\r\n  }\r\n  .descriptionFour {\r\n    font-size: 0.8rem;\r\n    font-weight: 400;\r\n    text-align: center;\r\n    width: 30vw;\r\n    margin-top: 1rem;\r\n    display: flex;\r\n    padding-bottom: 1rem;\r\n    color: rgba(0, 0, 0, 0.671);\r\n    margin-bottom: auto;\r\n    text-align:center\r\n  }\r\n}\r\n\r\n/* for mobile */\r\n@media (max-width: 770px) {\r\n\r\n.container {\r\n  margin-bottom: 0rem;\r\n}\r\n\r\n  .outerContainer {\r\n    box-shadow: none;\r\n    margin-bottom: 1.5rem;\r\n  }\r\n\r\n  .cardFour {\r\n    margin: 0.2rem;\r\n    height: 25rem;\r\n    padding: 0.5rem 0.4rem;\r\n    transition: none;\r\n    width: 80vw;\r\n    margin-bottom: 1rem;\r\n  }\r\n\r\n  .imageFour {\r\n    /* border-radius: 100%; */\r\n    height: 12rem;\r\n    width: 80vw;\r\n    object-fit: cover;\r\n    margin-top: 0rem;\r\n\r\n  }\r\n\r\n  .cardOne {\r\n    margin: 0.2rem;\r\n    height: 19rem;\r\n    padding: 0.5rem 0.4rem;\r\n    transition: none;\r\n    width: 80vw;\r\n  }\r\n\r\n  .imageOne {\r\n    /* border-radius: 100%; */\r\n    height: 12rem;\r\n    width: 80vw;\r\n    object-fit: cover;\r\n  }\r\n\r\n  .cardTwo {\r\n    margin: 0.2rem;\r\n    height: 19rem;\r\n    padding: 0.5rem 0.4rem;\r\n    transition: none;\r\n    width: 80vw;\r\n  }\r\n\r\n  .imageTwo {\r\n    /* border-radius: 100%; */\r\n    height: 12rem;\r\n    width: 80vw;\r\n    object-fit: cover;\r\n  }\r\n\r\n  .cardThree {\r\n    margin: 0.2rem;\r\n    height: 19rem;\r\n    padding: 0.5rem 0.4rem;\r\n    transition: none;\r\n    width: 80vw;\r\n  }\r\n\r\n  .imageThree {\r\n    /* border-radius: 100%; */\r\n    height: 12rem;\r\n    width: 80vw;\r\n    object-fit: cover;\r\n  }\r\n\r\n  .label {\r\n    font-size: 1.2rem;\r\n    font-weight: 400;\r\n    margin-top: 0.5rem;\r\n    margin-bottom: 0.4rem;\r\n  }\r\n\r\n  .button {\r\n    width: 100%;\r\n    font-size: 1rem;\r\n    padding-top: 0.2rem;\r\n    padding-bottom: 0.2rem;\r\n    margin-top: auto;\r\n    margin-bottom: 1rem;\r\n  }\r\n  .title {\r\n    text-align: center;\r\n    font-size: 2rem;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    margin-top: 0rem;\r\n  }\r\n  .typographyContainer {\r\n    text-align: left;\r\n    margin-top: 0rem;\r\n  }\r\n\r\n  .typography1 {\r\n    font-size: 20px;\r\n    padding: 1rem 0;\r\n    font-weight: 600;\r\n    margin-top: 0rem;\r\n  }\r\n\r\n  .typography2 {\r\n    font-size: 1rem;\r\n    margin-bottom: 0.5rem;\r\n  }\r\n  .descriptionFour {\r\n    font-size: 0.8rem;\r\n    font-weight: 400;\r\n    text-align: center;\r\n    width: 80vw;\r\n    margin-top: 1rem;\r\n    display: flex;\r\n    padding-bottom: 1rem;\r\n    color: rgba(0, 0, 0, 0.671);\r\n    margin-bottom: auto;\r\n    text-align:center\r\n  }\r\n}\r\n\r\n\r\n/* for 5 cards */\r\n.cardFive {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  padding: 0rem;\r\n  margin: 0 0.8rem;\r\n  margin-bottom: 1rem;\r\n  border: 1.5px solid #657fad00;\r\n  background: #ffffff;\r\n  height: 30rem;\r\n  width: 16vw;\r\n  transition: 0.5s;\r\n  position: relative;\r\n  border-radius: 0.5rem;\r\n}\r\n\r\n.imageFive {\r\n  height: 12rem;\r\n  width: 14vw;\r\n  object-fit: cover;\r\n  border-radius: 0.5rem;\r\n  border: 1px solid #657fad46;\r\n  margin-top: 0.8rem;\r\n}\r\n\r\n.descriptionFive {\r\n  font-size: 0.9rem;\r\n  font-weight: 400;\r\n  text-align: center;\r\n  width: 14vw;\r\n  margin-top: 1rem;\r\n  display: flex;\r\n  padding-bottom: 1rem;\r\n  color: rgba(0, 0, 0, 0.671);\r\n  margin-bottom: auto;\r\n}\r\n\r\n@media (max-width: 995px) {\r\n  .cardFive {\r\n    width: 38vw;\r\n    height: 28rem;\r\n  }\r\n  .imageFive {\r\n    width: 36vw;\r\n    height: 14rem;\r\n  }\r\n  .descriptionFive {\r\n    width: 35vw;\r\n    font-size: 0.8rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 770px) {\r\n  .cardFive {\r\n    width: 80vw;\r\n    height: 25rem;\r\n    margin: 0.4rem 0;\r\n  }\r\n  .imageFive {\r\n    width: 80vw;\r\n    height: 12rem;\r\n  }\r\n  .descriptionFive {\r\n    width: 80vw;\r\n    font-size: 0.8rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 1646px) {\r\n  .cardFive {\r\n    width: 15vw;\r\n  }\r\n  .imageFive {\r\n    width: 13vw;\r\n  }\r\n  .descriptionFive {\r\n    width: 13vw;\r\n  }\r\n}\r\n\r\n@media (min-width: 1829px) {\r\n  .cardFive {\r\n    width: 14vw;\r\n  }\r\n  .imageFive {\r\n    width: 12vw;\r\n  }\r\n  .descriptionFive {\r\n    width: 12vw;\r\n  }\r\n}\r\n\r\n@media (min-width: 2059px) {\r\n  .cardFive {\r\n    width: 13vw;\r\n  }\r\n  .imageFive {\r\n    width: 11vw;\r\n  }\r\n  .descriptionFive {\r\n    width: 11vw;\r\n  }\r\n}\r\n\r\n/* Large screen 1646px and above */\r\n@media (min-width: 1646px) {\r\n\r\n  .cardFour {\r\n      width: 18vw;\r\n  }\r\n  .imageFour {\r\n  width: 16vw;\r\n  }\r\n    .descriptionFour {\r\n    width: 16vw;\r\n  }\r\n\r\n    .cardFive {\r\n    width: 12vw;\r\n  }\r\n  .imageFive {\r\n    width: 11vw;\r\n  }\r\n  .descriptionFive {\r\n    width: 11vw;\r\n  }\r\n\r\n}\r\n\r\n@media (min-width: 1829px) {\r\n\r\n  .cardFour {\r\n      width: 14vw;\r\n  }\r\n  .imageFour {\r\n  width: 13vw;\r\n  }\r\n      .descriptionFour {\r\n    width: 13vw;\r\n  }\r\n}\r\n\r\n@media (min-width: 2059px) {\r\n\r\n  .cardFour {\r\n      width: 15vw;\r\n  }\r\n  .imageFour {\r\n  width: 14vw;\r\n  }\r\n      .descriptionFour {\r\n    width: 14vw;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `Categories_title__jq-BR`,
	"container": `Categories_container__sIrmY`,
	"typographyContainer": `Categories_typographyContainer__hEtVz`,
	"typography1": `Categories_typography1__9co+e`,
	"typography2": `Categories_typography2__mOnE-`,
	"cardOne": `Categories_cardOne__VFC-7`,
	"imageOne": `Categories_imageOne__FeemQ`,
	"descriptionOne": `Categories_descriptionOne__b2DBG`,
	"cardTwo": `Categories_cardTwo__sNPk8`,
	"imageTwo": `Categories_imageTwo__oc+hm`,
	"descriptionTwo": `Categories_descriptionTwo__CoDKL`,
	"cardThree": `Categories_cardThree__2E7Th`,
	"imageThree": `Categories_imageThree__VewxW`,
	"descriptionThree": `Categories_descriptionThree__NmUSU`,
	"cardFour": `Categories_cardFour__98-0K`,
	"imageFour": `Categories_imageFour__7SXZe`,
	"descriptionFour": `Categories_descriptionFour__uh3bX`,
	"cardItems": `Categories_cardItems__1wv8D`,
	"label": `Categories_label__es69G`,
	"description": `Categories_description__dLG4w`,
	"descriptionCollapsed": `Categories_descriptionCollapsed__zD+qe`,
	"descriptionExpanded": `Categories_descriptionExpanded__E2evz`,
	"button": `Categories_button__8OILF`,
	"outerContainer": `Categories_outerContainer__TgGXV`,
	"cardFive": `Categories_cardFive__U7djb`,
	"imageFive": `Categories_imageFive__aaG6a`,
	"descriptionFive": `Categories_descriptionFive__D4tLx`
};
export default ___CSS_LOADER_EXPORT___;
